/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Form, Select, Card, Row, Col, Typography, Spin, message } from 'antd';
import { CalendarOutlined, BankOutlined, UserOutlined } from '@ant-design/icons';
import { DatePicker } from '@material-ui/pickers';
import { useIntl } from 'react-intl';
import { settlementAPI, organisationAPI, settlementTypesAPI } from '../../../services/api';
import moment from 'moment';

const { Title, Text } = Typography;
const { Option } = Select;

// Step 1: Parties & Period
// - Loads settlement types and orgs (sender: my_company, beneficiary: pto)
// - Auto-selects the first available options if none chosen
// - Auto-calculates From Date based on beneficiary's earliest transaction date
// - Normalizes dates to YYYY-MM-DD to avoid timezone issues across steps
const Step1PartiesPeriod = ({ data, onDataChange, onNext }) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [settlementTypes, setSettlementTypes] = useState([]);
  const [senderOrgs, setSenderOrgs] = useState([]);
  const [beneficiaryOrgs, setBeneficiaryOrgs] = useState([]);
  const [autoFromDate, setAutoFromDate] = useState(null);
  const [isNeedToSettle, setIsNeedToSettle] = useState(true);
  useEffect(() => {
    loadInitialData();
    console.log("data : ", data);
  }, []);

  useEffect(() => {
    if (data.beneficiary_id) {
      calculateAutoFromDate();
    }
  }, [data.beneficiary_id]);

  useEffect(() => {
    // Initialize settlement_till_date with today's date and trigger onDataChange
    if (!form.getFieldValue('settlement_till_date')) {
      const today = moment();
      form.setFieldsValue({
        settlement_till_date: today
      });
      
      // Trigger onDataChange to enable Next button
      const formData = form.getFieldsValue();
      const updateData = {
        ...formData,
        settlement_till_date: today.format('YYYY-MM-DD')
      };
      onDataChange(updateData);
    }
  }, [form, onDataChange]);


  const loadInitialData = async () => {
    try {
      setLoading(true);
      const [typesRes, sendersRes, beneficiariesRes] = await Promise.all([
        settlementTypesAPI.getAll(),
        organisationAPI.getSettlementOrganisations('my_company'),
        organisationAPI.getSettlementOrganisations('pto')
      ]);

      // Handle API response structure: response.data.data for settlement types, response.data.data.organisations for orgs
      const settlementTypes = Array.isArray(typesRes.data?.data) ? typesRes.data.data : [];
      const senderOrgs = Array.isArray(sendersRes.data?.data?.organisations) ? sendersRes.data.data.organisations : [];
      const beneficiaryOrgs = Array.isArray(beneficiariesRes.data?.data?.organisations) ? beneficiariesRes.data.data.organisations : [];
      
      setSettlementTypes(settlementTypes);
      setSenderOrgs(senderOrgs);
      setBeneficiaryOrgs(beneficiaryOrgs);

      // Auto-select first available options if not already selected
      const autoSelections = {};
      
      if (!data.settlement_type_id && settlementTypes.length > 0) {
        autoSelections.settlement_type_id = settlementTypes[0].id;
        autoSelections.settlement_type_name = settlementTypes[0].type_en || settlementTypes[0].type_ar || settlementTypes[0].name;
      }
      
      if (!data.sender_id && senderOrgs.length > 0) {
        autoSelections.sender_id = senderOrgs[0].id;
        autoSelections.sender_name = senderOrgs[0].en_name || senderOrgs[0].name;
      }
      
      if (!data.beneficiary_id && beneficiaryOrgs.length > 0) {
        autoSelections.beneficiary_id = beneficiaryOrgs[0].id;
        autoSelections.beneficiary_name = beneficiaryOrgs[0].en_name || beneficiaryOrgs[0].name;
      }

      // Update form and data with auto-selections
      if (Object.keys(autoSelections).length > 0) {
        form.setFieldsValue(autoSelections);
        onDataChange(autoSelections);
      }
    } catch (error) {
      message.error('Failed to load initial data: ' + (error.response?.data?.message || error.message));
      // Set empty arrays on error to prevent map errors
      setSettlementTypes([]);
      setSenderOrgs([]);
      setBeneficiaryOrgs([]);
    } finally {
      setLoading(false);
    }
  };

  const calculateAutoFromDate = async () => {
    if (!data.beneficiary_id) return;

    try {
      // Backend computes min(ct.transaction_mtime_gmt) from org-specific view using beneficiary_id only
      const response = await settlementAPI.getAutoFromDate(data.beneficiary_id);
      const apiFrom = response.data?.data?.from_date || '1970-01-01';
      const needSettle = response.data?.data?.isNeedToSettle;
      setIsNeedToSettle(needSettle !== false); // treat undefined/true as enabled, only false disables
      // propagate to parent to control wizard footer buttons
      onDataChange({ is_need_to_settle: needSettle });
      // Normalize to YYYY-MM-DD to avoid timezone shifts when rendering/navigating
      const normalized = moment(apiFrom).format('YYYY-MM-DD');
      setAutoFromDate(moment(normalized));

      // Update form and data with normalized date string
      form.setFieldsValue({ settlement_from_date: moment(normalized) });
      onDataChange({ settlement_from_date: normalized });
    } catch (error) {
      // Non-blocking fallback
      // console.warn('Failed to calculate auto from date:', error);
      // Fallback to a default date
      const fallbackDate = moment().subtract(3, 'month');
      setAutoFromDate(fallbackDate);
      form.setFieldsValue({ settlement_from_date: fallbackDate });
      onDataChange({ settlement_from_date: fallbackDate.format('YYYY-MM-DD') });
    }
  };

  const handleFormChange = (changedFields, allFields) => {

   // alert(form);
    const formData = form.getFieldsValue();
    console.log("formData", formData);
    // Format dates properly
    const updateData = {
      ...formData,
      settlement_from_date: formData.settlement_from_date ? moment(formData.settlement_from_date).format('YYYY-MM-DD') : formData.settlement_from_date,
      settlement_till_date: formData.settlement_till_date ? moment(formData.settlement_till_date).format('YYYY-MM-DD') : formData.settlement_till_date
    };
     console.log("updateData", updateData);
    // Enrich with human-readable names for sender and beneficiary
    if (updateData.sender_id && Array.isArray(senderOrgs)) {
      const foundSender = senderOrgs.find(o => o.id === updateData.sender_id);
      if (foundSender) {
        updateData.sender_name = foundSender.en_name || foundSender.name;
      }
    }
    if (updateData.beneficiary_id && Array.isArray(beneficiaryOrgs)) {
      const foundBenef = beneficiaryOrgs.find(o => o.id === updateData.beneficiary_id);
      if (foundBenef) {
        updateData.beneficiary_name = foundBenef.en_name || foundBenef.name;
      }
    }
    // Enrich with human-readable settlement type name
    if (updateData.settlement_type_id && Array.isArray(settlementTypes)) {
      const foundType = settlementTypes.find(t => t.id === updateData.settlement_type_id);
      if (foundType) {
        updateData.settlement_type_name = foundType.type_en || foundType.type_ar || foundType.name;
      }
    }

    // If critical inputs that affect Step 2 summary changed, reset dependent fields to force fresh reload
    const beneficiaryChanged = updateData.beneficiary_id !== data.beneficiary_id;
    const senderChanged = updateData.sender_id !== data.sender_id;
    const fromChanged = updateData.settlement_from_date !== data.settlement_from_date;
    const tillChanged = updateData.settlement_till_date !== data.settlement_till_date;
    const typeChanged = updateData.settlement_type_id !== data.settlement_type_id;

    if (beneficiaryChanged || senderChanged || fromChanged || tillChanged || typeChanged) {
      // Step 2: Transaction Summary
      updateData.channels = [];
      updateData.amount = 0;
      updateData.fees_amount = 0;
      updateData.tax_amount = 0;

      // Step 3: Financial Accounts (reset all selections)
      updateData.sender_debit_account_id = null;
      updateData.sender_credit_account_id = null;
      updateData.sender_income_account_id = null;
      updateData.sender_tax_liability_account_id = null;
      updateData.beneficiary_debit_account_id = null;
      updateData.beneficiary_credit_account_id = null;
      updateData.beneficiary_expense_account_id = null;
      updateData.beneficiary_tax_asset_account_id = null;

      // Step 4: Bank Transfer (reset selections and helper displays)
      updateData.sender_selected_bank_id = null;
      updateData.beneficiary_selected_bank_id = null;
      updateData.sender_bank_id = null;
      updateData.beneficiary_bank_id = null;
      updateData.sender_bank_display = undefined;
      updateData.beneficiary_bank_display = undefined;

      // Optional: Clear notes as they may relate to previous selections
      updateData.notes = '';
    }
    //console.log("updateData", updateData);
    onDataChange(updateData);

  };
 
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
        <div style={{ marginTop: '16px' }}>Loading settlement data...</div>
      </div>
    );
  }

  return (
    <div className="step1-parties-period">
      <Card>
        <Title level={4}>
          <UserOutlined /> {intl.formatMessage({ id: 'settlement_SelectSenderAndBeneficiary' })}
        </Title>
        
        <Form
          form={form}
          layout="vertical"
          onValuesChange={handleFormChange}
          initialValues={{
            currency: 'EGP',
            settlement_type_id: data.settlement_type_id,
            sender_id: data.sender_id,
            beneficiary_id: data.beneficiary_id,
            settlement_from_date: data.settlement_from_date ? moment(data.settlement_from_date) : autoFromDate,
            settlement_till_date: data.settlement_till_date ? moment(data.settlement_till_date) : null
          }}
        >
          <Row gutter={[24, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                name="settlement_type_id"
                label={intl.formatMessage({ id: 'settlement_SettlementType' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectSettlementType' }) }]}
              >
                <Select
                  placeholder={intl.formatMessage({ id: 'settlement_SelectSettlementType' })}
                  size="large"
                  showSearch
                  optionFilterProp="children"
                >
                  {Array.isArray(settlementTypes) && settlementTypes.map(type => (
                    <Option key={type.id} value={type.id}>
                      {type.type_en}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="currency"
                label={intl.formatMessage({ id: 'settlement_Currency' })}
              >
                <Select disabled size="large">
                  <Option value="EGP">{intl.formatMessage({ id: 'settlement_EGPEgyptianPound' })}</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="sender_id"
                label={intl.formatMessage({ id: 'settlement_SenderOrganisation' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectSenderOrganisation' }) }]}
              >
                <Select
                  placeholder={intl.formatMessage({ id: 'settlement_SelectSenderOrganisation' })}
                  size="large"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {Array.isArray(senderOrgs) && senderOrgs.map(org => (
                    <Option key={org.id} value={org.id}>
                      <UserOutlined /> {org.en_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="beneficiary_id"
                label={intl.formatMessage({ id: 'settlement_BeneficiaryOrganisation' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectBeneficiaryOrganisation' }) }]}
              >
                <Select
                  placeholder={intl.formatMessage({ id: 'settlement_SelectBeneficiaryOrganisation' })}
                  size="large"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {Array.isArray(beneficiaryOrgs) && beneficiaryOrgs.map(org => (
                    <Option key={org.id} value={org.id}>
                      <BankOutlined /> {org.en_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Title level={5}>
                <CalendarOutlined /> {intl.formatMessage({ id: 'settlement_SettlementPeriod' })}
              </Title>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="settlement_from_date"
                label={intl.formatMessage({ id: 'settlement_FromDate' })}
                help={autoFromDate ? intl.formatMessage({ id: 'settlement_AutoCalculatedBasedOnPrevious' }) : ""}
              >
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  format="DD-MM-yyyy"
                  style={{ width: '100%', height: '35px' }}
                  InputProps={{ style: { height: '35px' } }}
                  disabled={!!autoFromDate}
                  value={form.getFieldValue('settlement_from_date') || null}
                  onChange={(date) => {
                    form.setFieldsValue({ settlement_from_date: date });
                    const formData = form.getFieldsValue();
                    const updateData = {
                      ...formData,
                      settlement_from_date: date ? moment(date).format('YYYY-MM-DD') : null,
                      settlement_till_date: formData.settlement_till_date ? moment(formData.settlement_till_date).format('YYYY-MM-DD') : formData.settlement_till_date
                    };
                    // Trigger the same logic as handleFormChange
                    if (updateData.sender_id && Array.isArray(senderOrgs)) {
                      const foundSender = senderOrgs.find(o => o.id === updateData.sender_id);
                      if (foundSender) {
                        updateData.sender_name = foundSender.en_name || foundSender.name;
                      }
                    }
                    if (updateData.beneficiary_id && Array.isArray(beneficiaryOrgs)) {
                      const foundBenef = beneficiaryOrgs.find(o => o.id === updateData.beneficiary_id);
                      if (foundBenef) {
                        updateData.beneficiary_name = foundBenef.en_name || foundBenef.name;
                      }
                    }
                    if (updateData.settlement_type_id && Array.isArray(settlementTypes)) {
                      const foundType = settlementTypes.find(t => t.id === updateData.settlement_type_id);
                      if (foundType) {
                        updateData.settlement_type_name = foundType.type_en || foundType.type_ar || foundType.name;
                      }
                    }
                    onDataChange(updateData);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="settlement_till_date"
                label={intl.formatMessage({ id: 'settlement_ToDate' })}
                initialValue={moment()}
                rules={[
                  { required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectEndDate' }) },
                  {
                    validator: (_, value) => {
                      if (value && moment(value).isAfter(moment(), 'day')) {
                        return Promise.reject(new Error(intl.formatMessage({ id: 'settlement_ToDateCannotBeFuture' })));
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  format="DD-MM-yyyy"
                  style={{ width: '100%', height: '35px' }}
                  InputProps={{ style: { height: '35px' } }}
                  disabled={!isNeedToSettle}
                  minDate={autoFromDate || moment().subtract(1, 'year')}
                  maxDate={moment()}
                  value={form.getFieldValue('settlement_till_date') || moment()}
                  onChange={(date) => {
                    form.setFieldsValue({ settlement_till_date: date });
                    const formData = form.getFieldsValue();
                    const updateData = {
                      ...formData,
                      settlement_from_date: formData.settlement_from_date ? moment(formData.settlement_from_date).format('YYYY-MM-DD') : formData.settlement_from_date,
                      settlement_till_date: date ? moment(date).format('YYYY-MM-DD') : null
                    };
                    // Trigger the same logic as handleFormChange
                    if (updateData.sender_id && Array.isArray(senderOrgs)) {
                      const foundSender = senderOrgs.find(o => o.id === updateData.sender_id);
                      if (foundSender) {
                        updateData.sender_name = foundSender.en_name || foundSender.name;
                      }
                    }
                    if (updateData.beneficiary_id && Array.isArray(beneficiaryOrgs)) {
                      const foundBenef = beneficiaryOrgs.find(o => o.id === updateData.beneficiary_id);
                      if (foundBenef) {
                        updateData.beneficiary_name = foundBenef.en_name || foundBenef.name;
                      }
                    }
                    if (updateData.settlement_type_id && Array.isArray(settlementTypes)) {
                      const foundType = settlementTypes.find(t => t.id === updateData.settlement_type_id);
                      if (foundType) {
                        updateData.settlement_type_name = foundType.type_en || foundType.type_ar || foundType.name;
                      }
                    }
                    onDataChange(updateData);
                    // Trigger validation after setting the value
                    form.validateFields(['settlement_till_date']);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {!isNeedToSettle && (
          <div style={{ marginTop: 8 }}>
            <Text type="danger" style={{ fontSize: 12 }}>
              {intl.formatMessage({ id: 'settlement_NoUnsettledTransactions' })}
            </Text>
          </div>
        )}

        {/** Navigation controls are handled by the parent wizard footer */}
      </Card>
    </div>
  );
};

export default Step1PartiesPeriod;
